import { Component, OnInit, Input } from '@angular/core';

import { Doctor } from './../doctor';
import { DoctorService } from './../../../../services/doctor.service';
import { Observable } from 'rxjs/Observable';
import { mergeMap } from 'rxjs/operators';
import { GlobalErrorHandlerService } from '../../../../services/global-error.service';

@Component({
  selector: 'app-doctors-listing',
  templateUrl: './doctors-listing.component.html',
  styleUrls: ['./doctors-listing.component.scss']
})
export class DoctorsListingComponent implements OnInit {

  public expanded_doctor: any = null;
  public group_array_for_pair: any[] = [];

  // Initialize this value explicitly
  public show_doctor_form: boolean = false;
  public show_doctors_listing: boolean = true;

  public doctor_listing_array: Doctor[] = [];
  public new_doctor: Doctor = new Doctor();
  public associate_doctor_profile: Doctor = null;

  public data_source: Observable<any>;
  public token: string = '';
  public asyncSelected: string = '';
  public typeaheadLoading: boolean = false;
  public typeaheadNoResults: boolean = false;

  @Input() practice: any;
  @Input() doctor_permissions: any;

  constructor(
    private doctorService: DoctorService,
    private globalErrorHandlerService: GlobalErrorHandlerService
  ) {
  }

  ngOnInit(): void {
    if (!this.practice || !this.practice.id) {
      return;
    }

    this.new_doctor = new Doctor();
    this.new_doctor.practice_id = this.practice_id;

    this.fetch_doctors();

    this.data_source = Observable.create((observer: any) => {
      observer.next(this.token);
    }).pipe(
      mergeMap((token: string) => {
        return this.doctorService.get_associated_doctors(
          token,
          this.practice_id
        );
      })
    );
  }

  get practice_id(): number {
    return this.practice ? this.practice.id : null;
  }

  fetch_doctors(): void {
    if (!this.practice_id) {
      return;
    }

    this.doctorService
      .getAllDoctorForPractice(this.practice_id)
      .then((json: any[]) => {
        this.doctor_listing_array = [];

        for (const doctor_profile of json) {
          const doctor = new Doctor();

          doctor.load_from_json(doctor_profile);
          doctor.practice_id = this.practice_id;

          this.doctor_listing_array.push(doctor);
        }

        this.set_pairs();
      })
      .catch((error: any) => {
        this.globalErrorHandlerService.error =
          'Unable to load doctors.';
      });
  }

  public changeTypeaheadLoading(value: boolean): void {
    this.typeaheadLoading = value;
  }

  public changeTypeaheadNoResults(value: boolean): void {
    this.typeaheadNoResults = value;
  }

  public typeaheadOnSelect(event: any): void {
    if (!event || !event.item || !event.item.id) {
      return;
    }

    this.doctorService
      .getDoctor(event.item.id)
      .then((json: any) => {
        this.associate_doctor_profile =
          new Doctor().load_from_json(json);
      })
      .catch((error: any) => {
        this.globalErrorHandlerService.error =
          'Unable to load doctor profile.';
      });
  }

  doctor_form(): void {
    // If the form is already open, close it
    if (this.show_doctor_form) {
      this.handle_new_doctor_hidden();
      return;
    }

    // Open a fresh doctor form
    this.associate_doctor_profile = null;

    this.new_doctor = new Doctor();
    this.new_doctor.practice_id = this.practice_id;

    this.show_doctor_form = true;
    this.show_doctors_listing = false;
  }

  doctor_listings(): Doctor[] {
    return this.doctor_listing_array.filter(
      (doctor: Doctor) => doctor.id
    );
  }

  group_in(array: Doctor[], group_length: number): Doctor[][] {
    const result: Doctor[][] = [];

    for (let i = 0; i < array.length; i += group_length) {
      result.push(array.slice(i, i + group_length));
    }

    return result;
  }

  set_pairs(): void {
    const doctors = this.doctor_listings();
    this.group_array_for_pair = this.group_in(doctors, 2);
  }

  doctor_expanded(doctor: any): void {
    if (
      this.expanded_doctor &&
      this.expanded_doctor !== doctor
    ) {
      this.expanded_doctor.collapse();
    }

    this.expanded_doctor = doctor;
  }

  handle_new_doctor_hidden(): void {
    this.show_doctor_form = false;
    this.show_doctors_listing = true;

    this.new_doctor = new Doctor();
    this.new_doctor.practice_id = this.practice_id;
  }

  doctor_saved(saved_doctor: Doctor): void {
    this.show_doctor_form = false;
    this.show_doctors_listing = true;

    this.new_doctor = new Doctor();
    this.new_doctor.practice_id = this.practice_id;

    // Reload the latest list from the server
    this.fetch_doctors();
  }

  associate_doctor_with_practice(): void {
    if (
      !this.associate_doctor_profile ||
      !this.associate_doctor_profile.id
    ) {
      return;
    }

    this.doctorService
      .associate_doctor_to_practice(
        this.practice_id,
        this.associate_doctor_profile.id
      )
      .then((json: any) => {
        this.fetch_doctors();
        this.renew_associate_doctor();
      })
      .catch((response: any) => {
        const errorMessage =
          response &&
          response.error &&
          response.error.error
            ? response.error.error
            : 'Unable to associate doctor.';

        if (errorMessage.includes('upgrade your account')) {
          this.globalErrorHandlerService.message =
            errorMessage.replace(
              'Validation failed: ',
              'Information Alert:'
            );
        } else {
          this.globalErrorHandlerService.error = errorMessage;
        }
      });
  }

  renew_associate_doctor(): void {
    this.associate_doctor_profile = null;
  }
}
